module.exports = __webpack_public_path__ + "img/triangulo-form-black.aa794550.png";